import React, { Fragment } from "react";

const CookiePage = () => {
  return (
    <Fragment>
      <div className="h-100 bg-plum-plate bg-animation">
        <div className="d-flex h-100 w-100 justify-content-center align-items-center">
          <div
            className="text-center text-white opacity-8 mt-3"
            style={{ width: "500px" }}
          >
            <h1> PRIVACY NOTICE </h1>
            <p> Last updated January 7, 2023</p>
            <p>
              Thank you for choosing to be part of our community at Trontech
              Inc., doing business as CyberSPF (“CyberSPF”, “we”, “us”, or
              “our”). We are committed to protecting your personal information
              and your right to privacy. If you have any questions or concerns
              about our policy, or our practices with regards to your personal
              information, please contact us at contact@trontechinc.com
            </p>
            <p>
              When you visit our website{" "}
              <a href="https://www.cyberspf.com" style={{ color: "black" }}>
                www.cyberpsf.com
              </a>{" "}
              and use our services, you trust us with your personal information.
              We take your privacy very seriously. In this privacy notice, we
              describe our privacy policy. We seek to explain to you in the
              clearest way possible what information we collect, how we use it
              and what rights you have in relation to it. We hope you take some
              time to read through it carefully, as it is important. If there
              are any terms in this privacy policy that you do not agree with,
              please discontinue use of our Sites and our services.
            </p>
            <p>
              This privacy policy applies to all information collected through
              our website (such as{" "}
              <a href="https://www.cyberspf.com" style={{ color: "black" }}>
                https://www.cyberpsf.com
              </a>
              ), and/or any related services, sales, marketing or events (we
              refer to them collectively in this privacy policy as the <b>"Sites"</b>).
            </p>
            Copyright &copy; CyberSPF 2023
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CookiePage;
